import type { TFunction } from 'i18next';

export type StatusMeta = {
  label: string;
  color: string;
};

export const getTaskStatusMeta = (status: number, t: TFunction): StatusMeta => {
  const map: Record<number, StatusMeta> = {
    1: { label: t('central.settlement.workflow.taskStatus.pending', { defaultValue: '待发起/待处理' }), color: 'default' },
    2: { label: t('central.settlement.workflow.taskStatus.inProgress', { defaultValue: '审核中' }), color: 'processing' },
    3: { label: t('central.settlement.workflow.taskStatus.approved', { defaultValue: '已通过' }), color: 'success' },
    4: { label: t('central.settlement.workflow.taskStatus.rejected', { defaultValue: '已驳回' }), color: 'error' },
    5: { label: t('central.settlement.workflow.taskStatus.cancelled', { defaultValue: '已取消' }), color: 'warning' },
  };
  return map[status] ?? { label: String(status), color: 'default' };
};

export const getNodeStatusMeta = (status: number, t: TFunction): StatusMeta => {
  const map: Record<number, StatusMeta> = {
    1: { label: t('central.settlement.workflow.nodeStatus.waiting', { defaultValue: '待审' }), color: 'processing' },
    2: { label: t('central.settlement.workflow.nodeStatus.approved', { defaultValue: '通过' }), color: 'success' },
    3: { label: t('central.settlement.workflow.nodeStatus.rejected', { defaultValue: '驳回' }), color: 'error' },
    4: { label: t('central.settlement.workflow.nodeStatus.skipped', { defaultValue: '跳过' }), color: 'default' },
  };
  return map[status] ?? { label: String(status), color: 'default' };
};
